import { Modal, Button, Flex } from 'antd';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PlanificationForm } from '@/components/Planification';
import { usePlanificationStates } from '@/hooks';

interface PlanificationFormRef {
  submit: () => void;
}

export const PlanificationModal: React.FC = () => {
  const { t } = useTranslation('DefaultTranslations');
  const formRef = useRef<PlanificationFormRef>(null);
  const { showPlanificationForm, setShowPlanificationForm } = usePlanificationStates();
  const [canCalculate, setCanCalculate] = useState(false);

  const handleCancel = () => {
    setShowPlanificationForm(false);
  };

  const handleCalculate = () => {
    formRef.current?.submit();
  };

  return (
    <Modal
      open={showPlanificationForm}
      destroyOnHidden
      onCancel={handleCancel}
      footer={null}
      centered
      width={600}>
      <Flex vertical gap={16} style={{ width: '100%' }}>
        {showPlanificationForm && (
          <PlanificationForm
            ref={formRef}
            onReadyToCalculateChange={isReady => setCanCalculate(isReady)}
          />
        )}

        <Flex justify="flex-end" gap={8}>
          <Button type="default" onClick={handleCancel}>
            {t('CANCEL')}
          </Button>
          <Button type="primary" disabled={!canCalculate} onClick={handleCalculate}>
            {t('CALCULATE_TIMES')}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
